import _defineProperty from "/var/jenkins_home/workspace/tingle.e49e9adf-d3ea-4dee-b9a2-f3d0e4982b89/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/var/jenkins_home/workspace/tingle.e49e9adf-d3ea-4dee-b9a2-f3d0e4982b89/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import { ButtonIcon, IconChevronDown, IconChevronUp } from '@spotify-internal/encore-web';
import { Link } from '../../ui';
import { RequireFeatureFlag } from '../../Auth/RequireFeatureFlag';
import { CloseSideMenuButton, StyledSideMenu, SideMenuAction, SidemenuSeparator, SideMenuLink, SideMenuCategory, SideMenuCategoryTitle, SideMenuCategoryItem } from './NavSideMenu.styles';
import { USE_SEARCH } from './constants';
import { isHelpLive } from '../../Help/util';
import { useT, useRtl } from '@mrkt/features/i18n';
import { getAccountsDomain } from '@mrkt/features/auth';
import { SideMenuLanguageSection } from './Language';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var TRACK_CAT = 'Side Nav';
export var NavSideMenu = function NavSideMenu(_ref) {
  var userState = _ref.userState,
      onClose = _ref.onClose;
  var t = useT();
  var rtl = useRtl();
  var showLogin = userState === 'loggedOut';
  var showLogout = userState === 'claimed' || userState === 'unclaimed';
  var showDashboard = userState === 'claimed';
  var showClaim = userState === 'unclaimed' || userState === 'loggedOut';

  var _React$useState = React.useState({}),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      menuState = _React$useState2[0],
      setMenuState = _React$useState2[1];

  var toggleMenu = function toggleMenu(key) {
    setMenuState(function (cur) {
      return _objectSpread(_objectSpread({}, cur), {}, _defineProperty({}, key, !cur[key]));
    });
  };

  return /*#__PURE__*/_jsxs(StyledSideMenu, {
    dir: rtl ? 'rtl' : 'ltr',
    id: "nav-sidemenu",
    tabIndex: 0,
    role: "dialog",
    "aria-label": t('FRODOR_NAV_RESPONSIVE_LABEL', 'Navigation dialog', 'Label for responsive navigation dialog'),
    children: [/*#__PURE__*/_jsx(CloseSideMenuButton, {
      tabIndex: 0,
      id: "close-sidemenu",
      onClick: onClose,
      onKeyDown: function onKeyDown(e) {
        if (e.key === ' ' || e.key === 'Enter') {
          e.preventDefault();
          onClose(e);
        }
      },
      "aria-label": t('FRODOR_NAV_RESPONSIVE_CLOSE', 'Close navigation menu', 'close navigation menu in responsive display')
    }), /*#__PURE__*/_jsxs("ul", {
      children: [showClaim && /*#__PURE__*/_jsx("li", {
        children: /*#__PURE__*/_jsx(SideMenuAction, {
          children: /*#__PURE__*/_jsx(Link, {
            "data-testid": "navigation-sidemenu-claim",
            track: [TRACK_CAT, "Get Access (".concat(userState, ")")],
            href: "/claim",
            prefetch: false,
            children: t('FRODOR_7b3ef2', 'Get access', '')
          })
        })
      }), showLogout && /*#__PURE__*/_jsx("li", {
        children: /*#__PURE__*/_jsx(SideMenuAction, {
          children: /*#__PURE__*/_jsx(Link, {
            "data-testid": "navigation-sidemenu-logout",
            track: [TRACK_CAT, 'Log Out'],
            href: "".concat(getAccountsDomain(), "/logout?continue=").concat(encodeURIComponent(window.location.href)),
            prefetch: false,
            children: t('FRODOR_4253b5', 'Log out', '')
          })
        })
      }), showLogin && /*#__PURE__*/_jsx("li", {
        children: /*#__PURE__*/_jsx(SideMenuAction, {
          children: /*#__PURE__*/_jsx(Link, {
            "data-testid": "navigation-sidemenu-login",
            track: [TRACK_CAT, 'Log In'],
            href: "".concat(getAccountsDomain(), "/login?continue=").concat(encodeURIComponent(window.location.href)),
            prefetch: false,
            children: t('FRODOR_284ac7', 'Log in', '')
          })
        })
      }), showDashboard && /*#__PURE__*/_jsx("li", {
        children: /*#__PURE__*/_jsx(SideMenuAction, {
          children: /*#__PURE__*/_jsx(Link, {
            track: [TRACK_CAT, 'Dashboard'],
            href: "/c",
            prefetch: false,
            "data-testid": "navigation-sidemenu-dashboard",
            children: t('FRODOR_a7d070', 'Dashboard', '')
          })
        })
      }), /*#__PURE__*/_jsx("li", {
        children: /*#__PURE__*/_jsx(SidemenuSeparator, {})
      }), /*#__PURE__*/_jsx("li", {
        children: /*#__PURE__*/_jsx(SideMenuLink, {
          children: /*#__PURE__*/_jsx(Link, {
            track: [TRACK_CAT, 'Features'],
            href: "/features",
            "data-testid": "navigation-sidemenu-features",
            children: t('FRODOR_3d7a71', 'Features', '')
          })
        })
      }), isHelpLive && /*#__PURE__*/_jsx("li", {
        children: /*#__PURE__*/_jsx(SideMenuLink, {
          children: /*#__PURE__*/_jsx(Link, {
            track: [TRACK_CAT, 'Help'],
            href: "/help",
            "data-testid": "navigation-sidemenu-help",
            children: t('FRODOR_1d93a2', 'Help', '')
          })
        })
      }), !isHelpLive && /*#__PURE__*/_jsx("li", {
        children: /*#__PURE__*/_jsxs(SideMenuCategory, {
          children: [/*#__PURE__*/_jsx(ButtonIcon, {
            onClick: function onClick() {
              return toggleMenu('help');
            },
            children: /*#__PURE__*/_jsxs(SideMenuCategoryTitle, {
              children: [t('FRODOR_1d93a2', 'Help', ''), menuState.help ? /*#__PURE__*/_jsx(IconChevronUp, {
                iconSize: 16,
                "aria-label": t('FRODOR_d8794a', 'Close help menu', '')
              }) : /*#__PURE__*/_jsx(IconChevronDown, {
                iconSize: 16,
                "aria-label": t('FRODOR_13855f', 'Open help menu', '')
              })]
            })
          }), menuState.help && /*#__PURE__*/_jsxs("ul", {
            children: [/*#__PURE__*/_jsx("li", {
              children: /*#__PURE__*/_jsx(SideMenuCategoryItem, {
                children: /*#__PURE__*/_jsx(Link, {
                  track: [TRACK_CAT, 'Guide'],
                  href: "/guide",
                  "data-testid": "navigation-sidemenu-guide",
                  children: t('FRODOR_b61355', 'Guide', '')
                })
              })
            }), /*#__PURE__*/_jsx("li", {
              children: /*#__PURE__*/_jsx(SideMenuCategoryItem, {
                children: /*#__PURE__*/_jsx(Link, {
                  track: [TRACK_CAT, 'FAQs'],
                  href: "/faq",
                  "data-testid": "navigation-sidemenu-faq",
                  children: "FAQ"
                })
              })
            })]
          })]
        })
      }), /*#__PURE__*/_jsx("li", {
        children: /*#__PURE__*/_jsxs(SideMenuCategory, {
          children: [/*#__PURE__*/_jsx(ButtonIcon, {
            onClick: function onClick() {
              return toggleMenu('resources');
            },
            children: /*#__PURE__*/_jsxs(SideMenuCategoryTitle, {
              children: [t('FRODOR_e8bb44', 'Resources', ''), menuState.resources ? /*#__PURE__*/_jsx(IconChevronUp, {
                iconSize: 16,
                "aria-label": t('FRODOR_04818c', 'Close resources menu', '')
              }) : /*#__PURE__*/_jsx(IconChevronDown, {
                iconSize: 16,
                "aria-label": t('FRODOR_4203b1', 'Open resources menu', '')
              })]
            })
          }), menuState.resources && /*#__PURE__*/_jsxs("ul", {
            children: [/*#__PURE__*/_jsx("li", {
              children: /*#__PURE__*/_jsx(SideMenuCategoryItem, {
                children: /*#__PURE__*/_jsx(Link, {
                  track: [TRACK_CAT, 'Videos'],
                  href: "/videos",
                  "data-testid": "navigation-sidemenu-videos",
                  children: t('FRODOR_9950ea', 'Videos', '')
                })
              })
            }), /*#__PURE__*/_jsx("li", {
              children: /*#__PURE__*/_jsx(SideMenuCategoryItem, {
                children: /*#__PURE__*/_jsx(Link, {
                  track: [TRACK_CAT, 'Blog'],
                  href: "/blog",
                  "data-testid": "navigation-sidemenu-blog",
                  children: t('FRODOR_278509', 'News', '')
                })
              })
            }), /*#__PURE__*/_jsx("li", {
              children: /*#__PURE__*/_jsx(SideMenuCategoryItem, {
                children: /*#__PURE__*/_jsx(Link, {
                  "data-testid": "navigation-sidemenu-events",
                  track: [TRACK_CAT, 'Events'],
                  href: "/events",
                  children: t('FRODOR_5172ce', 'Events', '')
                })
              })
            }), /*#__PURE__*/_jsx("li", {
              children: /*#__PURE__*/_jsx(SideMenuCategoryItem, {
                children: /*#__PURE__*/_jsx(Link, {
                  "data-testid": "navigation-sidemenu-promocards",
                  track: [TRACK_CAT, 'Promo Cards'],
                  href: "/promocards",
                  children: t('FRODOR_3697de', 'Promo Cards', 'Promo is short for promotional')
                })
              })
            })]
          })]
        })
      }), /*#__PURE__*/_jsx("li", {
        children: /*#__PURE__*/_jsx(SideMenuLink, {
          children: /*#__PURE__*/_jsx(Link, {
            track: [TRACK_CAT, 'Providers'],
            href: "/providers",
            "data-testid": "navigation-sidemenu-directory",
            prefetch: false,
            children: t('FRODOR_83327b', 'Providers', '')
          })
        })
      }), USE_SEARCH && /*#__PURE__*/_jsx(RequireFeatureFlag, {
        flag: "s4a-frodor-test",
        fallback: /*#__PURE__*/_jsx(_Fragment, {}),
        waiting: /*#__PURE__*/_jsx(_Fragment, {}),
        children: /*#__PURE__*/_jsx("li", {
          children: /*#__PURE__*/_jsx(SideMenuLink, {
            children: /*#__PURE__*/_jsx(Link, {
              track: [TRACK_CAT, 'Search'],
              href: "/search",
              "data-testid": "navigation-sidemenu-search",
              prefetch: false,
              children: t('FRODOR_6c677e', 'Search', '')
            })
          })
        })
      })]
    }), /*#__PURE__*/_jsx(SideMenuLanguageSection, {
      onButtonClick: onClose
    })]
  });
};